export default class UserGroupService {
  /** @ngInject **/
  constructor(
    $http,
    ngAuthSettings,
  ) {
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
  }

  getGroups(accountId) {
    return this.$http.get(this.#serviceBaseUrl(accountId));
  }

  getGroupsForUser(accountId) {
    return this.$http.get(this.#serviceBaseUrl(accountId) + '/user/groups');
  }

  createGroup(accountId, group) {
    return this.$http.post(this.#serviceBaseUrl(accountId), group);
  }

  updateGroup(accountId, group) {
    return this.$http.patch(this.#serviceBaseUrl(accountId) + '/' + group.id, group);
  }

  deleteGroup(accountId, groupId) {
    return this.$http.delete(this.#serviceBaseUrl(accountId) + '/' + groupId);
  }

  unlinkUserFromGroup(accountId, groupId, userId) {
    return this.$http.delete(this.#serviceBaseUrl(accountId) + '/' + groupId + '/users/' + userId);
  }

  linkExistingUserToGroup(accountId, groupId, userId) {
    return this.$http.post(this.#serviceBaseUrl(accountId) + '/' + groupId + '/users/' + userId);
  }

  #serviceBaseUrl(accountId) {
    return this.serviceBaseUri + accountId + '/managers';
  }
}